/**
 * @generated SignedSource<<c5657b76f3f774f1dfd4249e7d4af25f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProblemDifficultyLevelEnum = "high" | "highest" | "low" | "lowest" | "medium" | "%future added value";
export type BookScrapClassificationInput = {
  id: string;
};
export type BookBookScrapDeleteDialog_bookScrapClassificationMutation$variables = {
  input: BookScrapClassificationInput;
};
export type BookBookScrapDeleteDialog_bookScrapClassificationMutation$data = {
  readonly bookScrapClassification: {
    readonly difficultyLevel: ProblemDifficultyLevelEnum | null;
    readonly id: string;
    readonly problem: {
      readonly id: string;
      readonly objectUrl: string;
    };
    readonly problemBookPage: number;
    readonly problemNumber: string;
    readonly problemTex: string | null;
    readonly solution: {
      readonly id: string;
      readonly objectUrl: string;
    } | null;
    readonly solutionBookPage: number | null;
    readonly solutionTex: string | null;
    readonly unitD: {
      readonly id: string;
      readonly title: string;
      readonly unitATitle: string;
      readonly unitBTitle: string;
      readonly unitCTitle: string;
    } | null;
  };
};
export type BookBookScrapDeleteDialog_bookScrapClassificationMutation = {
  response: BookBookScrapDeleteDialog_bookScrapClassificationMutation$data;
  variables: BookBookScrapDeleteDialog_bookScrapClassificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BookScrap",
    "kind": "LinkedField",
    "name": "bookScrapClassification",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "difficultyLevel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitD",
        "kind": "LinkedField",
        "name": "unitD",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitATitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitBTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitCTitle",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemBookPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionBookPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "problem",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "solution",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemTex",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionTex",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookBookScrapDeleteDialog_bookScrapClassificationMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookBookScrapDeleteDialog_bookScrapClassificationMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6080734c63385d07245d2861539e9652",
    "id": null,
    "metadata": {},
    "name": "BookBookScrapDeleteDialog_bookScrapClassificationMutation",
    "operationKind": "mutation",
    "text": "mutation BookBookScrapDeleteDialog_bookScrapClassificationMutation(\n  $input: BookScrapClassificationInput!\n) {\n  bookScrapClassification(input: $input) {\n    id\n    difficultyLevel\n    unitD {\n      id\n      title\n      unitATitle\n      unitBTitle\n      unitCTitle\n    }\n    problemBookPage\n    solutionBookPage\n    problemNumber\n    problem {\n      id\n      objectUrl\n    }\n    solution {\n      id\n      objectUrl\n    }\n    problemTex\n    solutionTex\n  }\n}\n"
  }
};
})();

(node as any).hash = "e982e74478bb592c80814ffc0e818358";

export default node;
